import React from 'react';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, LabelList, Legend } from 'recharts';
import { Colors } from '../../../constants/Colors.js';

const AvancesComiteCoop = ({ dataGraficaMunicipios }) => {
  const valueAccessor = attribute => ({ payload }) => {
    let value = payload[attribute];
    if (value > 0) {
      if (value > 5) {
        return value;
      } else {
        return '';
      }
    } else {
      return '';
    }
  };

  return (
    <>
      {/* header title for total fichas de comité */}
      <div className="row">
        <div className="col-12">
          <h6 className="font-lato-normal-400 heading-box">Avance total de evaluaciones realizadas</h6>
        </div>
      </div>
      <ResponsiveContainer width="104%" height={120} className="barchart-horizontal-margin">
        <BarChart
          layout="vertical"
          data={[
            {
              name: 'Totales',
              total_fichas_comite: dataGraficaMunicipios.reduce((acc, current) => +acc + +current.total_fichas_comite, 0),
              total_fichas_comite_pendiente: dataGraficaMunicipios.reduce(
                (acc, current) => +acc + +current.total_fichas_comite_pendiente,
                0
              ),
            },
          ]}>
          <XAxis type="number" stroke="#666" axisLine={false} tickLine={false} tick={false} label={'Total de productores'} />
          <YAxis dataKey="name" type="category" stroke="#666" axisLine={false} tickLine={false} tick={false} />
          <Tooltip />
          <Legend />
          <Bar name="Realizado" radius={[5, 0, 0, 5]} dataKey="total_fichas_comite" stackId="a" fill={'#C7AE34'}>
            <LabelList
              style={{
                textAnchor: 'middle',
                fontSize: '14',
                fill: Colors.white,
              }}
              valueAccessor={valueAccessor('total_fichas_comite')}
            />
          </Bar>
          <Bar name="Pendiente" radius={[0, 5, 5, 0]} dataKey="total_fichas_comite_pendiente" stackId="a" fill={Colors.black_medium}>
            <LabelList
              style={{
                textAnchor: 'middle',
                fontSize: '14',
                fill: Colors.neutral_2,
              }}
              valueAccessor={valueAccessor('total_fichas_comite_pendiente')}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <div className="font-lato-normal-400 text-right pr-4" style={{ fontSize: 18 }}>
        Total de productores con levantamiento (SIC):{' '}
        <span className="nv-pie-title font-forum-normal-400">
          {dataGraficaMunicipios.reduce((acc, current) => +acc + +current.total_levantado, 0)}
        </span>
      </div>
    </>
  );
};

export default AvancesComiteCoop;
